<template>
  <div>
    <el-form label-position="left" label-width="200px">
      <el-form-item
        v-for="(item, key) in thirdPartySettings"
        :key="key"
        :label="labelLang(item.label, item.type, item.required)"
      >
        <template v-if="item.type === 'input' || item.type === 'password'">
          <el-input
            :type="item.type"
            v-model="item.value"
            @click.native.stop.prevent="handleClick(key)"
            @touchend.native.stop.prevent="handleClick(key)"
          ></el-input>
        </template>
        <template v-else-if="item.type === 'checkbox'">
          <input
            :type="item.type"
            v-model="item.value"
            style="float: left; margin-top: 10px"
            @click="checkedChanged(key)"
          />
        </template>
        <template v-else-if="item.type === 'select'">
          <el-select v-model="selectedValue" placeholder="" @change="selectChanged($event, key)">
            <el-option
              v-for="item in selections"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <template v-else-if="item.type === 'datetime'">
          <el-date-picker
            @change="dateTimeChanged($event, key)"
            style="width: 100%"
            v-model="item.value"
            type="datetime"
            placeholder="选择日期时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </template>
        <template v-else-if="item.type === 'button'">
          <el-button
            class="btn-oprator"
            style="font-size: 25px; width: 150px"
            @click="btnClick(key)"
          >
            {{ btnText }}
          </el-button>
        </template>
        <br />
      </el-form-item>
      <br />
    </el-form>
    <el-form label-width="200px">
      <el-form-item>
        <el-row>
          <el-col :span="12"> </el-col>
          <el-col :span="12">
            <el-button
              class="btn-oprator"
              @click="thirdClick()"
              style="font-size: 25px; width: 150px"
              >{{ $t("langcfg.txtBack") + $t("langcfg.txtLogin") }}</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { Message } from "../../../mixins";
import { saveThirdPartySettings } from "../../../settings";
import { isDefined, logStdout, objectCopy } from "../../../shared/utils";
import UDPClient from "../../js/udpClient";
let udpClient;
let timeout;
export default {
  data() {
    return {
      thirdPartySettings: {},
      isSearching: false,
      isServerSelVisible: false,
      selections: [],
      selectedValue: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "清除",
            onClick(picker) {
              picker.$emit("pick", null);
            }
          }
        ]
      },
      startTime: "",
      endTime: ""
    };
  },
  mixins: [Message],
  mounted() {
    this.thirdPartySettings = objectCopy(window.thirdPartySettings);
    for (let id in this.thirdPartySettings) {
      if (this.thirdPartySettings[id].type === "select") {
        this.selectedValue = this.thirdPartySettings[id].value;
        break;
      }
    }
    logStdout("thirdparty settings", this.thirdPartySettings);
  },
  beforeDestroy() {
    if (isDefined(udpClient)) {
      udpClient.clear();
    }
    if (this.thirdPartySettings && Object.keys(this.thirdPartySettings).length > 0) {
      window.thirdPartySettings = this.thirdPartySettings;
      saveThirdPartySettings(window.thirdPartySettings);
    }
  },
  props: {
    checked: false
  },
  watch: {
    checked: function (val) {
      if (this.thirdPartySettings && this.thirdPartySettings["auto"])
        this.thirdPartySettings["auto"].value = val;
    }
  },
  methods: {
    dateTimeChanged(val, key) {
      if (isDefined(val)) {
        window.thirdPartySettings[key].value = this.thirdPartySettings[key].value =
          val.format("yyyy-MM-dd HH:mm:ss");
        saveThirdPartySettings(window.thirdPartySettings);
      } else {
        window.thirdPartySettings[key].value = this.thirdPartySettings[key].value = "";
        saveThirdPartySettings(window.thirdPartySettings);
      }
      if (window.thirdpartyScript) {
        window.thirdpartyScript.init(window.thirdPartySettings);
      }
    },
    clearStartTime() {},
    selectChanged(val, key) {
      window.thirdPartySettings[key].value = this.thirdPartySettings[key].value = val;
      saveThirdPartySettings(window.thirdPartySettings);
    },
    selectServer() {
      this.isServerSelVisible = false;
    },
    checkedChanged(key) {
      window.thirdPartySettings[key].value = !window.thirdPartySettings[key].value;
      saveThirdPartySettings(window.thirdPartySettings);
      this.$bus.$emit("thirdparty-enabled", window.thirdPartySettings[key].value);
    },

    labelLang(txt, type, required = false) {
      if (type === "invisible") return "";
      return (txt.indexOf("langcfg.") >= 0 ? this.$t(txt) : txt) + (required ? "*" : "") + ":";
    },
    findServer() {
      if (this.isSearching) return;
      this.isSearching = true;
      let flag = true;
      udpClient = new UDPClient();
      udpClient.on("connections", (conns) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.selections = [];
          if (Object.keys(conns).length === 1) {
            const key = Object.keys(conns)[0];
            this.selections = [
              {
                value: this.selectedValue,
                label: conns[key].servername || `http://${conns[key].address}:41234`
              }
            ];
            this.selectedValue =
              this.thirdPartySettings.url.value = `http://${conns[Object.keys(conns)[0]].address}:41234`;
          } else if (Object.keys(conns).length > 1) {
            for (let id in conns) {
              if (this.thirdPartySettings.url.value === `http://${conns[id].address}:41234`) {
                flag = false;
              }
              this.selections.push({
                value: `http://${conns[id].address}:41234`,
                label: conns[id].servername || `http://${conns[id].address}:41234`
              });
            }
            if (flag) {
              this.selectedValue = `http://${conns[Object.keys(conns)[0]].address}:41234`;
              this.thirdPartySettings.url.value = `http://${conns[Object.keys(conns)[0]].address}:41234`;
            }
          } else if (Object.keys(conns).length === 0) {
            udpClient.clear();
            this.isSearching = false;
            this.selectedValue = "";
            this.thirdPartySettings.url.value = "";
            this.message(this.$t("langcfg.txtNoServer"), "error", 2000);
          }
          window.thirdPartySettings = this.thirdPartySettings;
          saveThirdPartySettings(window.thirdPartySettings);
          udpClient.clear();
          this.isSearching = false;
        }, 2000);
      });
      udpClient.findServer();
    },
    btnClick(key) {
      switch (key) {
        case "search":
          this.findServer();
          break;
        default:
          break;
      }
    },
    handleClick(key) {
      let self = this;
      if (
        self.thirdPartySettings[key].type !== "input" &&
        self.thirdPartySettings[key].type !== "password"
      )
        return;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.thirdPartySettings[key].value, (value) => {
        self.thirdPartySettings[key].value = value;
        window.thirdPartySettings[key].value = value;
        saveThirdPartySettings(window.thirdPartySettings);
        if (window.thirdpartyScript && typeof window.thirdpartyScript.init === "function") {
          window.thirdpartyScript.init(window.thirdPartySettings);
        }
      });
    },
    thirdClick() {
      this.$emit("thirdparty-click", "login");
    }
  },

  computed: {
    btnText() {
      const { defaultText, runText } = this.thirdPartySettings["search"];
      return this.isSearching ? this.$t(runText) : this.$t(defaultText);
    }
  }
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item__label {
  font-size: 30px;
  padding: 0px;
  line-height: 50px;
}

/deep/.el-form-item__error {
  margin-left: 20px;
}

.el-form-item {
  line-height: 40px;
  margin-top: 20px;
}

.Login {
  width: 800px;
  padding-left: 20px;
}

.login-tip {
  font-size: 20px;
  width: 100%;
  text-align: left;
  margin-left: 20px;
}

.login-tip-undo {
  color: white;
}

.login-tip-doing {
  color: white;
}

.login-tip-unlogined {
  color: white;
}

.login-tip-failed {
  color: white;
}

.protocol-url {
  display: inline-flex;
  width: 100%;
  margin-left: 20px;
  font-size: 20px;
}

.protocol {
  border: #dcdfe6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 50px;
  color: #606266;
}
input[type="checkbox"] {
  padding: 0px;
  border: none;
  width: 35px;
  height: 35px;
  margin-left: 30px;
}
.url {
  width: 100%;
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: none;
  font-size: 30px;
  outline: none;
  height: 50px;
  color: #606266;
}

.btn-oprator {
  height: @header-fs+30px;
  border: 1px gray solid;
}

.btn-oprator:hover {
  color: @btn-hover-color;

  i {
    color: @btn-hover-color;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: black;
}
.btn-oprator:active {
  background: @btn-active-color;
}
input[type="checkbox"] {
  margin-left: 0px;
}
.el-date-picker /deep/ .el-date-picker.has-sidebar.has-time {
  width: 800px;
}
.el-date-picker /deep/ .el-picker-panel__footer {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/FormThirdParty.vue